import React from "react";
import PropTypes from "prop-types";

const Page = ({ title, children }) => (
	<div className="box-body">
		{children}
	</div>
);
Page.propTypes = {
	title: PropTypes.string,
	children: PropTypes.node,
};

export default Page;
